import { Navigate } from "react-router-dom";
import useAuthStore from "@/store/use-auth-store";
import React from "react";
import {
  readAuthGateRedirect,
  readLastVisitedRoute,
} from "@/features/auth-gate";

interface PublicRouteProps {
  children: React.ReactNode;
}

export function PublicRoute({ children }: PublicRouteProps) {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated()) {
    return <>{children}</>;
  }

  // Login başarısında bu guard, LoginPage'in navigate() çağrısıyla yarışır
  // (React Router v7 navigasyonları transition olarak işler). Sabit "/"
  // yerine kayıtlı dönüş adresine gidilir ki kullanıcı login öncesi
  // kaldığı sayfadan devam edebilsin.
  const redirectPath =
    readAuthGateRedirect() ?? readLastVisitedRoute() ?? "/";

  return <Navigate to={redirectPath} replace />;
}
